module.exports = __webpack_public_path__ + "components/affiliate-fillers/booking/static/filler-c1a5c03b14b9fb01018a168be42153e5.jpg";